import { render, staticRenderFns } from "./ServiceProvidersServices.vue?vue&type=template&id=d7267fac&"
import script from "./ServiceProvidersServices.vue?vue&type=script&lang=ts&"
export * from "./ServiceProvidersServices.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceProvidersServices.vue?vue&type=style&index=0&id=d7267fac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports